import { Component } from '@angular/core';

@Component({
  selector: 'app-bg-loading-content-panel',
  templateUrl: './bg-loading-content-panel.component.html',
  styleUrls: ['./bg-loading-content-panel.component.scss'],
})
export class BgLoadingContentPanelComponent {}
